import axios from '../axios';

// 销售报价单主表列表
export const getSalQuotePage = data => {
  return axios({
    url: '/api/sys/sal/order/getSalQuotePage',
    method: 'post',
    data
  });
};

// 销售报价单主表列表（不分页）
export const getSalQuoteListNoPage = data => {
  return axios({
    url: '/api/sys/sal/order/getSalQuoteList',
    method: 'post',
    data
  });
};
// 查询单条销售报价单主表
export const getSalQuote = data => {
  return axios({
    url: '/api/sys/sal/order/getSalQuote',
    method: 'post',
    data
  });
};

// 保存销售报价单主表
export const saveSalQuote = data => {
  return axios({
    url: '/api/sys/sal/order/saveSalQuote',
    method: 'post',
    data
  });
};

// 修改销售报价单主表
export const updateSalQuote = data => {
  return axios({
    url: '/api/sys/sal/order/updateSalQuote',
    method: 'post',
    data
  });
};

// 销售报价单提交审批
export const submitSalQuote = data => {
  return axios({
    url: '/api/sys/sal/order/submitSalQuote',
    method: 'post',
    data
  });
};



// 删除销售报价单主表
export const deleteSalQuotes = data => {
  return axios({
    url: '/api/sys/sal/order/deleteSalQuotes',
    method: 'post',
    data
  });
};

// 状态启用/禁用  status 1可用 0不可用
export const statusSalQuotes = data => {
  return axios({
    url: '/api/sys/sal/order/statusSalQuotes',
    method: 'post',
    data
  });
};

// 审核/反审核  auditStatus 1已审核 0未审核
export const auditSalQuotes = data => {
  return axios({
    url: '/api/sys/sal/order/auditSalQuotes',
    method: 'post',
    data
  });
};

// 发货通知单列表
export const getSalNoticePage = data => {
  return axios({
    url: '/api/sys/sal/notice/getSalNoticePage',
    method: 'post',
    data
  });
};
// 发货通知单列表（不分页）
export const getSalNoticeList = data => {
  return axios({
    url: '/api/sys/sal/notice/getSalNoticeList',
    method: 'post',
    data
  });
};
// 发货通知单合计
export const getSalNoticeSum = data => {
  return axios({
    url: '/api/sys/sal/notice/getSalNoticeSum',
    method: 'post',
    data
  });
};
// 查询单条发货通知单
export const getSalNotice = data => {
  return axios({
    url: '/api/sys/sal/notice/getSalNotice',
    method: 'post',
    data
  });
};
// 保存发货通知单
export const saveSalNotice = data => {
  return axios({
    url: '/api/sys/sal/notice/saveSalNotice',
    method: 'post',
    data
  });
};
// 修改发货通知单
export const updateSalNotice = data => {
  return axios({
    url: '/api/sys/sal/notice/updateSalNotice',
    method: 'post',
    data
  });
};
// 删除发货通知单
export const deleteSalNotices = data => {
  return axios({
    url: '/api/sys/sal/notice/deleteSalNotices',
    method: 'post',
    data
  });
};
// 发货通知单状态启用/禁用
export const statusSalNotices = data => {
  return axios({
    url: '/api/sys/sal/notice/statusSalNotices',
    method: 'post',
    data
  });
};

// 发货通知单提交审批
export const submitSalNotice = data => {
  return axios({
    url: '/api/sys/sal/notice/submitSalNotice',
    method: 'post',
    data
  });
};

// 级联删除发货通知单主表及明细（逻辑删除）
export const deleteSalNoticesCascade = data => {
  return axios({
    url: '/api/sys/sal/notice/deleteSalNoticesCascade',
    method: 'post',
    data
  });
};

// 发货通知单明细列表
export const getSalNoticeEntryPage = data => {
  return axios({
    url: '/api/sys/sal/notice/entry/getSalNoticeEntryPage',
    method: 'post',
    data
  });
};

// 提货单列表
export const getSalDeliveryPage = data => {
  return axios({
    url: '/api/sys/sal/delivery/getSalDeliveryPage',
    method: 'post',
    data
  });
};
// 提货单合计
export const getSalDeliverySum = data => {
  return axios({
    url: '/api/sys/sal/delivery/getSalDeliverySum',
    method: 'post',
    data
  });
};
// 查询单条提货单
export const getSalDelivery = data => {
  return axios({
    url: '/api/sys/sal/delivery/getSalDelivery',
    method: 'post',
    data
  });
};
// 保存提货单
export const saveSalDelivery = data => {
  return axios({
    url: '/api/sys/sal/delivery/saveSalDelivery',
    method: 'post',
    data
  });
};
// 修改提货单
export const updateSalDelivery = data => {
  return axios({
    url: '/api/sys/sal/delivery/updateSalDelivery',
    method: 'post',
    data
  });
};
// 删除提货单
export const deleteSalDeliverys = data => {
  return axios({
    url: '/api/sys/sal/delivery/deleteSalDeliverys',
    method: 'post',
    data
  });
};
// 提货单状态启用/禁用
export const statusSalDeliverys = data => {
  return axios({
    url: '/api/sys/sal/delivery/statusSalDeliverys',
    method: 'post',
    data
  });
};
// 销售提货单明细列表
export const getSalDeliveryEntryPage = data => {
  return axios({
    url: '/api/sys/sal/delivery/entry/getSalDeliveryEntryPage',
    method: 'post',
    data
  });
};

// 保存销售报价单主表及明细
export const saveSalQuoteWithEntries = data => {
  return axios({
    url: '/api/sys/sal/order/saveSalQuoteWithEntries',
    method: 'post',
    data
  });
};

// 销售报价单明细列表
export const getSalQuoteEntryPage = data => {
  return axios({
    url: '/api/sys/sal/order/entry/getSalQuoteEntryPage',
    method: 'post',
    data
  });
};

// 销售报价单明细合计
export const getSalQuoteEntrySum = data => {
  return axios({
    url: '/api/sys/sal/order/entry/getSalQuoteEntrySum',
    method: 'post',
    data
  });
};

// 级联删除销售报价单主表及明细（逻辑删除）
export const deleteSalQuotesCascade = data => {
  return axios({
    url: '/api/sys/sal/order/deleteSalQuotesCascade',
    method: 'post',
    data
  });
};

// 通知单下推生成提货单
export const pushDownToDelivery = data => {
  return axios({
    url: '/api/sys/sal/notice/pushDownToDelivery',
    method: 'post',
    data
  });
};

// 保存通知单主表及明细
export const saveSalNoticeWithEntries = data => {
  return axios({
    url: '/api/sys/sal/notice/saveSalNoticeWithEntries',
    method: 'post',
    data
  });
};

// 销售车辆入场
export const entry = data => {
  return axios({
    url: '/api/sys/sal/delivery/entry',
    method: 'post',
    data
  });
};
// 销售一次重
export const salOneWeight = data => {
  return axios({
    url: '/api/sys/sal/delivery/salOneWeight',
    method: 'post',
    data
  });
};
// 销售二次重
export const salTwoWeight = data => {
  return axios({
    url: '/api/sys/sal/delivery/salTwoWeight',
    method: 'post',
    data
  });
};
// 销售车辆出厂
export const exit = data => {
  return axios({
    url: '/api/sys/sal/delivery/exit',
    method: 'post',
    data
  });
};
// 提货单复磅
export const repeatWeight = data => {
  return axios({
    url: '/api/sys/sal/delivery/repeatWeight',
    method: 'post',
    data
  });
};
// 清除称重记录
export const deleteSalDeliveryEntryWeight = data => {
  return axios({
    url: '/api/sys/sal/delivery/entry/deleteSalDeliveryEntryWeight',
    method: 'post',
    data
  });
};
// 提货单结算
export const settlement = data => {
  return axios({
    url: '/api/sys/sal/delivery/settlement',
    method: 'post',
    data
  });
};
// 提货单反结算
export const reverseSettlement = data => {
  return axios({
    url: '/api/sys/sal/delivery/reverseSettlement',
    method: 'post',
    data
  });
};
// 销售收款/反收款
export const paymentReceipt = data => {
  return axios({
    url: '/api/sys/sal/delivery/paymentReceipt',
    method: 'post',
    data
  });
};
// 销售预约
export const saleAppointment = data => {
  return axios({
    url: '/api/sys/sal/notice/saleAppointment',
    method: 'post',
    data
  });
};

// 销售空车出场
export const emptyCarOut = data => {
  return axios({
    url: '/api/sys/sal/delivery/emptyCarOut',
    method: 'post',
    data
  });
};


// WEBPACK FOOTER //
// ./src/api/moudules/Sale.js